module.exports = __webpack_public_path__ + "static/media/scarfreefoundation.2247e2e7.png";